import { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';

const SmoothScroll = () => {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        // Expose for programmatic smooth scrolling (e.g. Back to Top button)
        window.lenis = lenis;

        const onAnchor = (e) => {
            const link = e.target.closest('a[href^="#"]');
            if (!link) return;
            const id = link.getAttribute('href');
            if (!id || id === '#') return;
            const target = document.querySelector(id);
            if (target) {
                e.preventDefault();
                lenis.scrollTo(target, { offset: -12, duration: 1.4 });
            }
        };
        document.addEventListener('click', onAnchor);
        return () => {
            document.removeEventListener('click', onAnchor);
            cancelAnimationFrame(rafId);
            lenis.destroy();
            delete window.lenis;
        };
    }, []);
    return null;
};

export default SmoothScroll;
